import React from 'react';
import PackingListView from './PackinListView';
import PackingListEdit from './PackingListEdit';

interface PackingListProps {
  import_id: string | null;
  editable: boolean;
  editableUser: any;
  importStatus: string | null;
  onPackingListChange?: (lines: any[]) => void;
}

const PackingList: React.FC<PackingListProps> = ({
  import_id,
  editable,
  editableUser,
  importStatus,
  onPackingListChange,
}) => {
  return editable ? (
    <PackingListEdit
      import_id={import_id}
      editable={editable}
      editableUser={editableUser}
      importStatus={importStatus}
      onPackingListChange={onPackingListChange}
    />
  ) : (
    <PackingListView import_id={import_id} />
  );
};

export default PackingList;
